<form name="TaxCategoryForm" (ngSubmit)="Validate(TaxCategoryForm)" #TaxCategoryForm="ngForm">
    <div class="card">
        <div class="card-header">
            <label>Tax Category</label>
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-md-12 px-1">
                    <label for="Name">Name</label>
                    <input type="text" [maxLength]="100" class="form-control" name="Name" placeholder="Ex. Name"
                        [(ngModel)]="Detail.Name" #Name="ngModel" required>
                    <div class="invalid-feedback">
                        Please enter name !
                    </div>
                </div>
                <div class="col-md-6 px-1">
                    <label for="FromAge">From Age</label>
                    <input type="text" class="form-control" placeholder="Ex. 18" id="FromAge" name="FromAge"
                        [(ngModel)]="Detail.FromAge" #FromAge="ngModel" pattern="^[0-9]\d*$"
                        (keypress)="common.NumberOnly($event)" maxlength="3">
                    <div class="invalid-feedback">
                        Please enter from age !
                    </div>
                </div>
                <div class="col-md-6 px-1">
                    <label for="ToAge">To Age</label>
                    <input type="text" class="form-control" placeholder="Ex. 30" id="ToAge" name="ToAge"
                        [(ngModel)]="Detail.ToAge" #ToAge="ngModel" pattern="^[0-9]\d*$"
                        (keypress)="common.NumberOnly($event)" maxlength="3">
                    <div class="invalid-feedback">
                        Please enter to age !
                    </div>
                </div>
                <!-- <div class="col-md-6 px-1">
                    <label for="Category">Category</label>
                    <select class="form-control form-select" name="Category" [(ngModel)]="Detail.Category"
                        #Category="ngModel" required>
                        <option [value]=null hidden disabled>Select Category</option>
                        <option value='Male'>Male</option>
                        <option value='Female'>Female</option>
                        <option value='Other'>Other</option>
                    </select>
                    <div class="invalid-feedback">
                        Please select category.
                    </div>
                </div> -->
            </div>
        </div>
        <div class="card-footer">
            <div class="row">
                <div class="col"></div>
                <div class="col-auto">
                    <button type="button" class="btn btn-outline-primary me-1" (click)="close()" [disabled]="isDisabled"
                        ngbTooltip="Cancel" container="body" placement="top">
                        Cancel
                        <span *ngIf="isDisabled" class="spinner-border spinner-border-sm" role="status"
                            aria-hidden="true"></span>
                    </button>

                    <button
                        *ngIf="(this.Detail.ESS_TaxCategoryMasterID == 0 && this.common.PageRight.IsAdd) || (this.Detail.ESS_TaxCategoryMasterID > 0 && this.common.PageRight.IsEdit)"
                        type="submit" class="btn btn-primary" [disabled]="isDisabled"><i class="bi bi-save2"
                            *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'Save':'Loading...'}}</button>
                </div>
            </div>
        </div>

    </div>
</form>